var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 7C1.25 3.82436 3.82436 1.25 7 1.25H17C20.1756 1.25 22.75 3.82436 22.75 7V17C22.75 20.1756 20.1756 22.75 17 22.75H7C3.82436 22.75 1.25 20.1756 1.25 17V7ZM7.0498 13.2998C7.74016 13.2998 8.2998 12.7402 8.2998 12.0498C8.2998 11.3594 7.74016 10.7998 7.0498 10.7998C6.35945 10.7998 5.7998 11.3594 5.7998 12.0498C5.7998 12.7402 6.35945 13.2998 7.0498 13.2998ZM13.2998 12.0498C13.2998 12.7402 12.7402 13.2998 12.0498 13.2998C11.3594 13.2998 10.7998 12.7402 10.7998 12.0498C10.7998 11.3594 11.3594 10.7998 12.0498 10.7998C12.7402 10.7998 13.2998 11.3594 13.2998 12.0498ZM17.0498 13.2998C17.7402 13.2998 18.2998 12.7402 18.2998 12.0498C18.2998 11.3594 17.7402 10.7998 17.0498 10.7998C16.3594 10.7998 15.7998 11.3594 15.7998 12.0498C15.7998 12.7402 16.3594 13.2998 17.0498 13.2998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.db0cd1b9a014d978ebfa7a3a831663ca.svg";
export { ForwardRef as ReactComponent };